import React, {useEffect} from "react";
import Loading from "../../components/layout/loading";

const Terms = () => {

    useEffect(() => {
        window.location.href = "https://app.minigoal.it/pages/terms";
    }, []);

    return (
        <Loading />
    )


};

export default Terms;
